import { S3_BUCKET_URL } from '@/constants';

import { SettingSelectorOptionsType } from './types';

export const SETTING_SELECTOR_OPTIONS: SettingSelectorOptionsType = [
  {
    id: 'wild_night_club',
    title: 'A wild night club',
    spriteSrc: '',
  },
  {
    id: 'smoky_jazz_bar',
    title: 'A smoky jazz bar',
    spriteSrc: '',
  },
  {
    id: 'spontaneous_tinder_date',
    title: 'A spontaneous Tinder date',
    spriteSrc: '',
  },
  {
    id: 'random_beach_meetup',
    title: 'A random beach meetup',
    spriteSrc: '',
  },
  {
    id: 'quiet_bookstore_cafe',
    title: 'A quiet bookstore café',
    spriteSrc: '',
  },
];

export const SETTING_SELECTOR_IMAGES = SETTING_SELECTOR_OPTIONS.map(
  (option) => ({
    ...option,
    spriteSrc: `${S3_BUCKET_URL}/layout-own-ai-constructor/setting-selector/${option.id.replace(/_/g, '-')}.png`,
  }),
);

export const GREAT_CHOICE_IMAGES = SETTING_SELECTOR_OPTIONS.map((option) => ({
  ...option,
  spriteSrc: `${S3_BUCKET_URL}/layout-own-ai-constructor/great-choice/${option.id.replace(/_/g, '-')}.png`,
}));
